import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';

/** Warianty i tłumaczenia napisów z planszy. Układ zostaje nietknięty. */
export type AdCopyMode = 'variants' | 'translate';

export interface AdCopyItem {
  id: string;
  text: string;
}

export interface AdCopyRequest {
  mode: AdCopyMode;
  items: AdCopyItem[];
  language?: string;
  context?: string;
}

export interface AdCopyResult {
  mode: AdCopyMode;
  items: Array<{ id: string; options: string[] }>;
}

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

/** Języki oferowane przy tłumaczeniu kreacji. */
export const AD_COPY_LANGUAGES: { code: string; label: string }[] = [
  { code: 'en', label: 'angielski' },
  { code: 'de', label: 'niemiecki' },
  { code: 'cs', label: 'czeski' },
  { code: 'uk', label: 'ukraiński' },
  { code: 'fr', label: 'francuski' },
  { code: 'es', label: 'hiszpański' },
  { code: 'it', label: 'włoski' },
];

export const useGenerateAdCopy = (): UseMutationResult<AdCopyResult, AxiosError, AdCopyRequest> => useMutation<
  AdCopyResult,
  AxiosError,
  AdCopyRequest
>({
  mutationFn: async (request) => {
    const res = await axiosInstance.post<ApiResponse<AdCopyResult>>('/v3-generateAdCopy', request, {
      timeout: 120_000,
    });
    return res.data.data;
  },
});
